import React from 'react';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class Clausura2006 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 460; i <= 477; i++) {
        	id_list.push(i);
        }
    this.state = {
	showCards: true,
      path: this.props.path,
	kit_path: '/images/kits/todas/',
      kits: [],
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,
      table1:[
		{'color':'#295e1e','shortname':'audax', 'rivalName':'Audax Italiano', 'pj':18, 'pg':9,'pe':2,'pp':7,'gf':32,'gc':24,'dif':8, 'pts':29},
		{'color':0,'shortname':'laserena', 'rivalName':'La Serena', 'pj':18, 'pg':4,'pe':6,'pp':8,'gf':32,'gc':39,'dif':-7, 'pts':18},
	       {'color':0,'shortname':'morning', 'rivalName':'S. Morning', 'pj':18, 'pg':4,'pe':5,'pp':9,'gf':22,'gc':32,'dif':-10, 'pts':17},	
		{'color':'#295e1e','shortname':'puertomontt', 'rivalName':'Puerto Montt', 'pj':18, 'pg':10,'pe':3,'pp':5,'gf':26,'gc':21,'dif':5, 'pts':33},
              {'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':18, 'pg':7,'pe':4,'pp':7,'gf':34,'gc':30,'dif':4, 'pts':25},
],

	table2:[{'color':'#135683','shortname':'cobreloa', 'rivalName':'Cobreloa', 'pj':18, 'pg':11,'pe':4,'pp':3,'gf':40,'gc':24,'dif':16, 'pts':37},
              {'color':'#295e1e','shortname':'audax', 'rivalName':'Audax Italiano', 'pj':18, 'pg':9,'pe':2,'pp':7,'gf':32,'gc':24,'dif':8, 'pts':29},
              {'color':'#295e1e','shortname':'puertomontt', 'rivalName':'Puerto Montt', 'pj':18, 'pg':10,'pe':3,'pp':5,'gf':26,'gc':21,'dif':5, 'pts':33},
	      {'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':18, 'pg':7,'pe':4,'pp':7,'gf':34,'gc':30,'dif':4, 'pts':25},
              {'color':'#295e1e','shortname':'catolica', 'rivalName':'U. Católica', 'pj':18, 'pg':9,'pe':4,'pp':5,'gf':24,'gc':18,'dif':6, 'pts':31},
              {'color':'#295e1e','shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':18, 'pg':8,'pe':5,'pp':5,'gf':37,'gc':31,'dif':6, 'pts':29},
              {'color':0,'shortname':'cobresal', 'rivalName':'Cobresal', 'pj':18, 'pg':5,'pe':3,'pp':10,'gf':20,'gc':28,'dif':-8, 'pts':18},
              {'color':0,'shortname':'huachipato', 'rivalName':'Huachipato', 'pj':18, 'pg':6,'pe':2,'pp':10,'gf':29,'gc':32,'dif':-3, 'pts':20},
              {'color':'#295e1e','shortname':'udechile', 'rivalName':'U. de Chile', 'pj':18, 'pg':7,'pe':2,'pp':9,'gf':24,'gc':25,'dif':-1, 'pts':23},
              {'color':0,'shortname':'rangers', 'rivalName':'Rangers', 'pj':18, 'pg':6,'pe':6,'pp':6,'gf':22,'gc':24,'dif':-2, 'pts':24},
              {'color':0,'shortname':'wanderers', 'rivalName':'S. Wanderers', 'pj':18, 'pg':8,'pe':4,'pp':6,'gf':22,'gc':21,'dif':1, 'pts':28},
              {'color':0,'shortname':'union', 'rivalName':'U. Española', 'pj':18, 'pg':3,'pe':5,'pp':10,'gf':20,'gc':34,'dif':-14, 'pts':14},
              {'color':'#295e1e','shortname':'ohiggins', 'rivalName':'O\'Higgins', 'pj':18, 'pg':10,'pe':5,'pp':3,'gf':31,'gc':20,'dif':11, 'pts':35},
	      {'color':0,'shortname':'laserena', 'rivalName':'La Serena', 'pj':18, 'pg':4,'pe':6,'pp':8,'gf':32,'gc':39,'dif':-7, 'pts':18},
	      {'color':0,'shortname':'everton', 'rivalName':'Everton', 'pj':18, 'pg':5,'pe':6,'pp':7,'gf':23,'gc':27,'dif':-4, 'pts':21},
              {'color':0,'shortname':'palestino', 'rivalName':'Palestino', 'pj':18, 'pg':5,'pe':5,'pp':8,'gf':16,'gc':25,'dif':-9, 'pts':18},
              {'color':0,'shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':18, 'pg':5,'pe':6,'pp':7,'gf':25,'gc':25,'dif':0, 'pts':21},
		{'color':0,'shortname':'morning', 'rivalName':'S. Morning', 'pj':18, 'pg':4,'pe':5,'pp':9,'gf':22,'gc':32,'dif':-10, 'pts':17},
              {'color':'#295e1e','shortname':'coquimbo', 'rivalName':'Coquimbo Unido', 'pj':18, 'pg':8,'pe':5,'pp':5,'gf':23,'gc':22,'dif':1, 'pts':29}],

	table3:[{'color':0,'shortname':'cobreloa', 'rivalName':'Cobreloa', 'pj':36, 'pg':20,'pe':7,'pp':9,'gf':72,'gc':48,'dif':24, 'pts':67},
              {'color':0,'shortname':'audax', 'rivalName':'Audax Italiano', 'pj':36, 'pg':18,'pe':7,'pp':11,'gf':64,'gc':46,'dif':18, 'pts':61},
              {'color':0,'shortname':'puertomontt', 'rivalName':'Puerto Montt', 'pj':36, 'pg':14,'pe':8,'pp':14,'gf':59,'gc':53,'dif':6, 'pts':50},
              {'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':36, 'pg':16,'pe':10,'pp':10,'gf':65,'gc':53,'dif':12, 'pts':58},
              {'color':0,'shortname':'catolica', 'rivalName':'U. Católica', 'pj':36, 'pg':18,'pe':9,'pp':9,'gf':51,'gc':38,'dif':13, 'pts':63},
              {'color':0,'shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':36, 'pg':21,'pe':6,'pp':9,'gf':91,'gc':53,'dif':38, 'pts':69},
              {'color':0,'shortname':'cobresal', 'rivalName':'Cobresal', 'pj':36, 'pg':11,'pe':7,'pp':18,'gf':46,'gc':60,'dif':-14, 'pts':40},
              {'color':0,'shortname':'huachipato', 'rivalName':'Huachipato', 'pj':36, 'pg':17,'pe':5,'pp':14,'gf':61,'gc':51,'dif':10, 'pts':56},
              {'color':0,'shortname':'udechile', 'rivalName':'U. de Chile', 'pj':36, 'pg':17,'pe':7,'pp':12,'gf':51,'gc':45,'dif':6, 'pts':58},
              {'color':'#E4AB27','shortname':'rangers', 'rivalName':'Rangers', 'pj':36, 'pg':10,'pe':10,'pp':16,'gf':48,'gc':64,'dif':-16, 'pts':40},
              {'color':0,'shortname':'wanderers', 'rivalName':'S. Wanderers', 'pj':36, 'pg':13,'pe':6,'pp':17,'gf':38,'gc':51,'dif':-13, 'pts':45},
              {'color':0,'shortname':'union', 'rivalName':'U. Española', 'pj':36, 'pg':11,'pe':9,'pp':16,'gf':44,'gc':55,'dif':-11, 'pts':42},
              {'color':0,'shortname':'ohiggins', 'rivalName':'O\'Higgins', 'pj':36, 'pg':15,'pe':11,'pp':10,'gf':51,'gc':45,'dif':6, 'pts':56},
              {'color':0,'shortname':'laserena', 'rivalName':'La Serena', 'pj':36, 'pg':9,'pe':13,'pp':14,'gf':64,'gc':70,'dif':-6, 'pts':40},
              {'color':0,'shortname':'everton', 'rivalName':'Everton', 'pj':36, 'pg':10,'pe':12,'pp':14,'gf':43,'gc':54,'dif':-11, 'pts':42},
              {'color':'#E4AB27','shortname':'palestino', 'rivalName':'Palestino', 'pj':36, 'pg':9,'pe':9,'pp':18,'gf':38,'gc':60,'dif':-22, 'pts':36},
              {'color':0,'shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':36, 'pg':10,'pe':12,'pp':14,'gf':51,'gc':56,'dif':-5, 'pts':42},
                {'color':'#E42727','shortname':'morning', 'rivalName':'S. Morning', 'pj':36, 'pg':6,'pe':11,'pp':19,'gf':37,'gc':63,'dif':-26, 'pts':29},
              {'color':0,'shortname':'coquimbo', 'rivalName':'Coquimbo Unido', 'pj':36, 'pg':11,'pe':13,'pp':12,'gf':39,'gc':48,'dif':-9, 'pts':46}]

    };
  }

  componentDidMount() {
		this.getKits();
		let _newtable = this.sortTable(this.state.table1);
                this.setState({table1:_newtable});
		let newtable = this.sortTable(this.state.table2);
  		this.setState({table2:newtable});
		let newtable2 = this.sortTable(this.state.table3);
                this.setState({table3:newtable2});
	}

getKits(){

        fetch("https://www.registrosudec.com:5000/kits", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", soc$
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}


  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={3} xl={3} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color} style={{width:'20px'}}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
			aux = table[j+1];
			table[j+1] = table[j];
                        table[j] = aux;
		} 
	     }		
	}
return table;

}


render(){


  let subT = this.subText('#295e1e', 'Clasificado a Play-Off');
  let subC = this.subText('#135683', 'Clasificado a Play-Off y a Libertadores 2007');
  let subP = this.subText('#E4AB27', 'Juega Liguilla Promoción');
  let subD = this.subText('#E42727', 'Desciende a Primera B');
  return(

	<div style={{textAlign: 'center' }}>
	 <div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Clausura 2006</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>

      <div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Grupo 3 </div>
	<div style={{ height: '10px' }}></div>
	{<Tabla teams={this.state.table1} />}
        <div style={{ height: '10px' }}></div>
         {subT}


	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Tabla General</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table2} />}

	{subT}
	{subC}
	
	<div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos"> Tabla Anual 2006</div>
        <div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table3} />}

        {subP}
	{subD}


	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Clausura 2006</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Clausura 2006</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Clausura 2006" />
     </div>


  )
}

}
export default Clausura2006;
